import type { Step } from '@/lib/dd-queue/types'

/** Ordered D&D step catalog — must stay identical to PHP STEP_LIBRARY + contracts/dd-workflow-step-library.json. */
export const STEP_LIBRARY: Step[] = [
  { key: 'pm_assessment', name: 'Triage', role: 'engineer', type: 'manual', phase: 'intake', unassignable: true },
  { key: 'design', name: 'Design', role: 'design', type: 'manual', phase: 'design_est' },
  { key: 'estimation', name: 'Estimation', role: 'estimate', type: 'manual', phase: 'design_est', external: true },
  { key: 'product_review', name: 'Product Review', role: 'engineer', type: 'manual', phase: 'product_review' },
  { key: 'sales_approval', name: 'Sales Review', role: 'sales', type: 'manual', phase: 'approval', external: true },
  { key: 'sku', name: 'SKU Assignment', role: 'engineer', type: 'manual', phase: 'system' },
  { key: 'uin', name: 'UIN Assignment', role: 'engineer', type: 'manual', phase: 'system', conditional: true },
  { key: 'production_file', name: 'Pre-press', role: 'prepress', type: 'manual', phase: 'deliverables' },
  { key: 'outsource_file', name: 'Vendor File', role: 'prepress', type: 'manual', phase: 'deliverables' },
  { key: 'signagent_svg', name: 'SignAgent SVG', role: 'prepress', type: 'manual', phase: 'deliverables' },
  { key: 'web_image', name: 'Web Image', role: 'design', type: 'manual', phase: 'deliverables' },
  { key: 'instructions', name: 'Instructions', role: 'engineer', type: 'manual', phase: 'deliverables' },
  { key: 'assembled_view', name: 'Assembled View', role: 'engineer', type: 'manual', phase: 'deliverables' },
  { key: 'install_notes', name: 'Install Notes', role: 'engineer', type: 'manual', phase: 'deliverables' },
  { key: 'hardware', name: 'Hardware', role: 'engineer', type: 'manual', phase: 'deliverables' },
  { key: 'pim_publish', name: 'Publish to PIM', role: 'engineer', type: 'manual', phase: 'closeout' },
  { key: 'piq_quickpart', name: 'PIQ Quick Part', role: 'engineer', type: 'manual', phase: 'closeout' },
  { key: 'web_publish', name: 'Publish to Web', role: 'engineer', type: 'manual', phase: 'closeout' },
]

export const STEPS_BY_KEY = Object.fromEntries(STEP_LIBRARY.map((s) => [s.key, s]))

export const DELIVERABLE_PHASE_KEYS = STEP_LIBRARY.filter((s) => s.phase === 'deliverables').map(
  (s) => s.key
)

export const CLOSEOUT_KEYS = STEP_LIBRARY.filter((s) => s.phase === 'closeout').map((s) => s.key)
